import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import type { MapboxStyle } from "@/types/mapbox-styles";

import { mapboxAccountUsername } from "./base-layer-styles";

/**
 * Styles owned by `VITE_MAP_USERNAME` (Mapbox Styles API). Used by the map widget CMS and
 * any UI that lists account base layers.
 */
export function useMapboxAccountStylesQuery() {
  const mapboxUsername = mapboxAccountUsername();
  const mapboxAccessToken =
    "sk.eyJ1IjoiaW8tZGlnaXRhbCIsImEiOiJjbG51ZnNjNWwwY3JjMmlubGxqd3p1ZThkIn0.0_vY9hcKZT002gB3B2XjFw";

  return useQuery({
    queryKey: ["mapboxstyles"],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://api.mapbox.com/styles/v1/${mapboxUsername}?access_token=${mapboxAccessToken}`,
      );
      return data as MapboxStyle[];
    },
  });
}
